import { __makeTemplateObject } from "tslib";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
export var SubitemContainer = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 8px;\n  border-radius: 8px;\n\n  text-decoration: none;\n  color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n\n  transition: all 0.3s;\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", "60;\n  }\n"], ["\n  padding: 8px;\n  border-radius: 8px;\n\n  text-decoration: none;\n  color: ", ";\n  font-family: ", ";\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n\n  transition: all 0.3s;\n\n  ", "\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  &:active {\n    background-color: ", "60;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.darker;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
}, function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return isActive && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", "60;\n    "], ["\n      background-color: ", "60;\n    "])), theme.colors.primary.lightest);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.lightest;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.lightest;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map